import ProductService from "../services/ProductService";

export default {
  namespaced: true,
  state: {
    user: null,
    isUserLoggedIn: false,
    userCatalogs: null,
    SelectedStateCode: null,
    SelectedStateName: null
  },
  getters: {
    getUser: state => state.user,
    getIsUserLoggedIn: state => state.isUserLoggedIn,
    getIsUserLimited: state => (state.user ? state.user.IsUserLimited : false),
    getuserCatalogs: state => state.userCatalogs,
    getUserStates: state => state.UserStates,
    getSelectedStateCode: state => state.SelectedStateCode,
    getSelectedStateName: state => state.SelectedStateName,
    getShowStatesOnPDP: state => state.ShowStatesOnPDP,
  },
  mutations: {
    UPDATE_USER(state, newUser) {
      state.user = newUser.User;
      state.isUserLoggedIn = newUser.IsUserLoggedIn;
      state.userCatalogs = newUser.UserCatalogs;
      state.UserStates = newUser.lstUserStates;
      state.ShowStatesOnPDP = newUser.ShowStatesOnPDP

    },
    TOGGLE_FAKE_LOGIN(state) {
      state.isUserLoggedIn = !state.isUserLoggedIn;
    },
    UPDATE_SELECTED_STATE(state, value){
      if(value!=null){
      state.SelectedStateCode =value.StateAbbreviation;
      state.SelectedStateName =value.StateName;
      }else{
        state.SelectedStateCode =null;
        state.SelectedStateName =null;

      }
    }
  },

  actions: {
    fakeLoginUserForTesting({ commit }) {
      commit("TOGGLE_FAKE_LOGIN");
    },
    updateSelectedState({ commit }, value) {
      commit("UPDATE_SELECTED_STATE",value);
    },
    async loadProductUser({ commit }) {
      await ProductService.getProductUser()
        .then(response => {
          return response.data;
        })
        .then(data => commit("UPDATE_USER", data))
        .catch(e => {
          throw e;
        });
    }
  }
};
